<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        (click)="dismiss()"
        ngxTippy
        [tippyProps]="{
          arrow: false,
          placement: 'bottom'
        }"
        data-tippy-content="Back to conversation"
      >
        <ion-icon
          name="chevron-back-outline"
          class="icon-padded-right"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="conversation">
      {{ inboundEmail?.subject }}
      <a (click)="dismiss()">[#{{ conversation.friendlyId }}]</a>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid style="padding: 0">
    <ion-row>
      <ion-col
        size-xl="9"
        size-lg="8"
        size-md="6"
        size="12"
        style="min-height: calc(100vh - 112px); padding: 0"
      >
        <ion-list
          *ngIf="inboundEmail"
          class="transparent-bg no-padding"
          style="border-bottom: 1px solid var(--ion-color-step-50)"
        >
          <ion-item>
            <app-avatar
              size="36"
              [style.width]="'36px'"
              [style.height]="'36px'"
              [name]="
                inboundEmail.fromUser?.name || inboundEmail.fromUser?.email
              "
              slot="start"
              [style.margin-right]="'10px'"
            >
            </app-avatar>
            <ion-label>
              <h3>{{ inboundEmail.fromUser?.name }}</h3>
              <p>{{ inboundEmail.fromUser?.email }}</p>
            </ion-label>
            <ion-label slot="end" *ngIf="blockLabel">
              <ion-badge color="danger">{{ blockLabel }}</ion-badge>
            </ion-label>
            <ion-buttons slot="end">
              <ion-button
                (click)="dismiss()"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom'
                }"
                data-tippy-content="Reply"
              >
                <ion-icon name="custom-reply"></ion-icon>
              </ion-button>
              <ion-button
                (click)="showOptions()"
                ngxTippy
                [tippyProps]="{
                  arrow: false,
                  placement: 'bottom'
                }"
                data-tippy-content="Show message options"
              >
                <ion-icon name="ellipsis-vertical"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-item>
        </ion-list>
        <div
          *ngIf="inboundEmail"
          [innerHTML]="inboundEmail.htmlContent"
          style="padding: 20px"
        ></div>
        <div
          style="text-align: center; padding-top: 40px"
          *ngIf="!inboundEmail"
        >
          <ion-spinner name="crescent"></ion-spinner>
        </div>
      </ion-col>
      <ion-col size-md="6" size-xl="3" size-lg="4" size="12" class="right-col">
        <div class="right-menu">
          <h3 style="margin: 15px 15px 0 15px; font-size: 1.1rem">
            Email Details
          </h3>
          <div
            style="text-align: center; padding-top: 40px"
            *ngIf="!inboundEmail"
          >
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          <ion-list class="transparent-bg" lines="none" *ngIf="inboundEmail">
            <ion-item>
              <ion-label text-wrap>
                <p>Subject</p>
                <h3>
                  {{ inboundEmail.subject }}
                </h3>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-label text-wrap>
                <p>From</p>
                <h3>
                  {{ inboundEmail.fromUser.email }}
                </h3>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-label text-wrap>
                <p>To</p>
                <h3 *ngFor="let to of inboundEmail.tos">
                  <span *ngIf="to.name">{{ to.name }} <{{ to.email }}></span>
                  <span *ngIf="!to.name">{{ to.email }}</span>
                </h3>
              </ion-label>
            </ion-item>
            <ion-item *ngIf="inboundEmail.ccs?.length">
              <ion-label text-wrap>
                <p>cc</p>
                <h3 *ngFor="let cc of inboundEmail.ccs">
                  <span *ngIf="cc.name">{{ cc.name }} <{{ cc.email }}></span>
                  <span *ngIf="!cc.name">{{ cc.email }}</span>
                </h3>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-label text-wrap>
                <p>Received</p>
                <h3>
                  {{
                    inboundEmail.inbound?.timestamp | date: "MMM d yyyy h:mm a"
                  }}
                </h3>
              </ion-label>
            </ion-item>
            <ion-item *ngIf="inboundEmail.attachments?.length">
              <ion-label text-wrap>
                <p>Attachments ({{ inboundEmail.attachments.length }})</p>
                <ng-container
                  *ngFor="let attachment of inboundEmail.attachments"
                >
                  <ion-button
                    color="light"
                    (click)="downloadAttachment(attachment.slackId)"
                    *ngIf="attachment.slackId"
                  >
                    <ion-icon
                      name="attach-outline"
                      class="padded-icon"
                    ></ion-icon>
                    {{ attachment.filename }}
                  </ion-button>
                </ng-container>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
